import { FunctionComponent } from 'react'

import { RootStackScreenComponentProps } from 'src/navigation'

export type HiringBensScreenComponent = FunctionComponent<HiringBensScreenProps>

export type HiringBensScreenProps = RootStackScreenComponentProps<'HiringBens'>

export type ResponsiveHiringBensScreenComponent = FunctionComponent<ReturnType<UseHiringBensScreen>>

export type UseHiringBensScreen = ({
  navigation
}: Pick<HiringBensScreenProps, 'navigation' | 'route'>) => {
  isMobile: boolean
  url?: string
}

// PowerApps URLs constants
export const POWERAPPS_BASE_URL =
  'https://apps.powerapps.com/play/e/fa202e3d-3516-e92f-a526-7811aa5d3b46'

export const TENANT_ID = '35595a02-4d6d-44ac-99e1-f9ab4cd872db'

export const HIRING_URLS = {
  SIM_WALLETS_MANAGEMENT: `${POWERAPPS_BASE_URL}/a/44469483-5654-46d5-b424-b47e75dce4cd?tenantId=${TENANT_ID}&hint=5ac2a45d-785c-4b3c-8d88-1a6b0634442f`,
  SIM_GOALS: `${POWERAPPS_BASE_URL}/a/7a678cf4-0fe6-4574-a4ba-39ed19f78eab?tenantId=${TENANT_ID}&hint=b9be5e1e-de1e-4c9b-b05f-aba9ab9e17fa`,
  SIM_DELEGATION: `${POWERAPPS_BASE_URL}/a/a68b9a25-9c68-42bb-83e4-93b08620ab91?tenantId=${TENANT_ID}&hint=fa8c3a50-25e4-4a0a-9435-a50159dd5d4b`,
  SIM_MIGRATION: `${POWERAPPS_BASE_URL}/a/c73fcc49-b285-47bd-b4f8-dd15bc92888d?tenantId=${TENANT_ID}&hint=38affd5d-f039-4ce4-8f9f-61e5b243774f`
} as const
